import React from 'react';
import { SectionHeading, SpecSection } from './SectionHeading';
import { agents } from '../../data/agents';
const layers = [{
  id: 'anna',
  name: 'Anna-modus',
  tagline: 'Ambient en spraakgestuurd',
  devices: 'Wandtablets · bureauscherm · telefoon',
  points: ['Anna is het middelpunt. Geen zijbalk, geen paginamenu.', 'Inhoud verschijnt als hij relevant is en verdwijnt als hij klaar is: een generatief podium.', 'Kaarten komen uit Anna voort en keren naar haar terug.', 'Op de wandtablet leesbaar van 2 tot 3 meter.']
}, {
  id: 'beheer',
  name: 'Beheer',
  tagline: 'De controlekamer',
  devices: 'Via de kleine Beheer-knop',
  points: ['Rustige, conventionele app voor instellingen, rechten, geheugen en logboek.', 'Mag eruitzien als een verzorgde admin-app.', 'Dezelfde vaste regels: niveaus, huismodi en agents heten hier precies hetzelfde.']
}];
function AnnaSchematic() {
  return <div aria-hidden className="relative aspect-[16/10] overflow-hidden rounded-2xl border border-white/[0.07] bg-night-900" data-id="element-1040" data-mp="1dn0nf2u56fqs">
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(circle at 50% 48%, rgb(var(--accent) / 0.18), transparent 45%)'
    }} data-id="element-1041" data-mp="18p7gg7l0lhpg" />
      <div className="absolute left-5 right-5 top-4 flex justify-between" data-id="element-1042" data-mp="znre8n4cslwb">
        <span className="h-2 w-12 rounded-full bg-white/20" data-id="element-1043" data-mp="zpu333trs8zg" />
        <span className="h-2 w-20 rounded-full bg-white/10" data-id="element-1044" data-mp="up6eeot0k48e" />
      </div>
      <span className="absolute left-1/2 top-[46%] h-10 w-10 -translate-x-1/2 -translate-y-1/2 rounded-full bg-accent/70" data-id="element-1045" data-mp="pxema9u7lqg5" />
      <span className="absolute left-1/2 top-[66%] h-2 w-28 -translate-x-1/2 rounded-full bg-white/25" data-id="element-1046" data-mp="kzd5xwo6458d" />
      <span className="glass absolute left-[8%] top-[24%] h-[34%] w-[24%] rounded-lg" data-id="element-1047" data-mp="g138ffez0sjl" />
      <span className="glass absolute left-[12%] top-[62%] h-[18%] w-[20%] rounded-lg opacity-60" data-id="element-1048" data-mp="bwlp1hciwh9c" />
      <span className="glass absolute right-[8%] top-[30%] h-[30%] w-[24%] rounded-lg" data-id="element-1049" data-mp="7051ao98k4ws" />
      <div className="absolute bottom-4 left-5 flex gap-1.5" data-id="element-1050" data-mp="3tfj6kiftq6at">
        {agents.slice(0, 4).map(a => <span key={a.id} className="h-1 w-6 rounded-full" style={{
        backgroundColor: a.color
      }} data-id="element-1051" data-mp="1duui6ua293x" />)}
      </div>
    </div>;
}
function BeheerSchematic() {
  return <div aria-hidden className="flex aspect-[16/10] overflow-hidden rounded-2xl border border-white/[0.07] bg-night-900" data-id="element-1052" data-mp="3ogzjgephuogv">
      <div className="flex w-[24%] flex-col gap-2.5 border-r border-white/[0.06] p-4" data-id="element-1053" data-mp="g30o9facj74f">
        <span className="mb-2 h-5 w-5 rounded-full bg-accent/60" data-id="element-1054" data-mp="l12a27z5pkjl" />
        {[70, 55, 80, 60, 50, 65].map((w, i) => <span key={i} className={`h-2 rounded-full ${i === 0 ? 'bg-white/30' : 'bg-white/10'}`} style={{
        width: `${w}%`
      }} data-id="element-1055" data-mp="6b37zu4hdoyu" data-mpi={i} />)}
      </div>
      <div className="flex flex-1 flex-col gap-3 p-5" data-id="element-1056" data-mp="z0jxaiwt0pqu">
        <span className="h-3 w-1/3 rounded-full bg-white/25" data-id="element-1057" data-mp="yyz7f6lfpuzb" />
        {[0, 1, 2, 3, 4].map(i => <div key={i} className="flex items-center gap-3 border-b border-white/[0.05] pb-3" data-id="element-1058" data-mp="13sv2o1abd3qs">
            <span className="h-2 w-2 rounded-full bg-white/20" data-id="element-1059" data-mp="2og4hypiyqhwq" />
            <span className="h-2 flex-1 rounded-full bg-white/10" data-id="element-1060" data-mp="2jje1i138xkas" />
            <span className="h-2 w-12 rounded-full bg-white/10" data-id="element-1061" data-mp="2x9zn3xk348cd" />
          </div>)}
      </div>
    </div>;
}
export function LayersSection() {
  return <SpecSection id="lagen" data-id="element-1062" data-mp="2t8xkd6qyle5n">
      <SectionHeading id="lagen" index={1} title="Twee lagen" intro="Anna-modus is levend en bouwt zich op rond wat Anna zegt. Beheer is de rustige kant voor alles wat je instelt en nakijkt." data-id="element-1063" data-mp="2tarxvzzwi3zp" />
      <div className="mt-14 grid gap-12 lg:grid-cols-2 lg:gap-0 lg:divide-x lg:divide-white/[0.07]" data-id="element-1064" data-mp="2ek16gt2816x4">
        {layers.map((layer, i) => <div key={layer.id} className={i === 0 ? 'lg:pr-12' : 'lg:pl-12'} data-id="element-1065" data-mp="29j3n4d5h66u1" data-mpi={i}>
            {layer.id === 'anna' ? <AnnaSchematic data-id="element-1066" data-mp="3pwttjqk2h76u" /> : <BeheerSchematic data-id="element-1067" data-mp="3q0hn2ppihtlk" />}
            <div className="mt-8 flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-1068" data-mp="3l03ft9vqinol">
              <h3 className="text-[24px] font-semibold text-ink" data-id="element-1069" data-mp="k4dvl1pswyjs">{layer.name}</h3>
              <span className="text-[16px] text-ink-muted" data-id="element-1070" data-mp="k6qjrwm5k55a">{layer.tagline}</span>
            </div>
            <p className="mt-1 text-[14px] text-ink-muted" data-id="element-1071" data-mp="p5a7o2kb3r0a">{layer.devices}</p>
            <ul className="mt-6 space-y-3" data-id="element-1072" data-mp="u0z1rqdk4fp7">
              {layer.points.map(p => <li key={p} className="flex gap-3 text-[16px] leading-relaxed text-ink-soft" data-id="element-1073" data-mp="z2en7jjnco84">
                  <span aria-hidden className="mt-[11px] h-1 w-1 shrink-0 rounded-full bg-ink-muted" data-id="element-1074" data-mp="132gp9ttanjnx" />
                  {p}
                </li>)}
            </ul>
          </div>)}
      </div>
    </SpecSection>;
}